import { Dialog, DialogTitle } from '@mui/material'
import React from 'react'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const MyModal = ({ open, setOpen, header, content, disableClickOutside, classNameAdd }) => {
  return (
    <Dialog
        open={open}
        onClose={e => {
            if (!disableClickOutside) {
				setOpen(false)
			}
        }}
        aria-labelledby="responsive-dialog-title"
        className={classNameAdd ? `${classNameAdd} myModal` : 'myModal'}
    >
        <div className='myModal__headerBlock'>
            <p className='myModal__header'>
                { 
                    header 
                }
            </p>
            <div
                className='myModal__close'
                onClick={e => setOpen(false)}
            >
                <CloseRoundedIcon />
            </div>
        </div>
        <div className='myModal__content'>
            {
                content
            }
        </div>
    </Dialog>
  )
}

export default MyModal